import { useAxiosConfig } from '@shared/api/AxiosConfigProvider';
import {
  useGroupCompanyReportsDashboardRetrieve,
  useGroupDashboardRetrieve,
  useGroupPurchasesDashboardRetrieve,
} from '@shared/api/lib/group/group';
import {
  GroupCompanyReportsDashboardRetrieveParams,
  GroupPurchasesDashboardRetrieveParams,
} from '@shared/api/types';

/**
 * Compound payload for the main group dashboard: hero KPIs plus per-section
 * adoption/emissions time series and the product rating distribution.
 */
export const useGetGroupDashboard = () =>
  useGroupDashboardRetrieve({
    request: useAxiosConfig(),
  });

/**
 * Compound payload for the company emissions dashboard: scope hero totals
 * plus over-time / by-organisation / by-category breakdowns.
 */
export const useGetGroupCompanyReportsDashboard = (
  params: GroupCompanyReportsDashboardRetrieveParams
) =>
  useGroupCompanyReportsDashboardRetrieve(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });

/**
 * Compound payload for the purchasing emissions dashboard: group totals plus
 * over-time / by-organisation / by-supplier breakdowns, each split between
 * food & drink and packaging.
 */
export const useGetGroupPurchasesDashboard = (
  params: GroupPurchasesDashboardRetrieveParams
) =>
  useGroupPurchasesDashboardRetrieve(params, {
    request: useAxiosConfig(),
    query: {
      // keepPreviousData: true,
    },
  });
